import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/admin/login',
    method: 'post',
    data
  })
}

export function getInfo() {
  return request({
    url: '/auth/me',
    method: 'get'
  })
}

// 管理员修改自己的密码
export function changePassword(data) {
  return request({
    url: '/admin/change-password',
    method: 'put',
    data
  })
}

// 获取待审核用户列表
export function getPendingUsers(params) {
  return request({
    url: '/admin/pending-users',
    method: 'get',
    params
  })
}

// 审核用户
export function verifyUser(userId, data) {
  return request({
    url: `/admin/verify-user/${userId}`,
    method: 'put',
    data
  })
}

// 获取用户列表
export function getUserList(params) {
  return request({
    url: '/admin/users',
    method: 'get',
    params
  })
}

// 更新用户状态
export function updateUserStatus(userId, status) {
  return request({
    url: `/admin/users/${userId}/status`,
    method: 'put',
    data: { status }
  })
}

// 身份升级（注册页六档等级）申请列表
export function getMembershipRequests(params) {
  return request({
    url: '/admin/membership-requests',
    method: 'get',
    params
  })
}

// 审核身份升级申请（approved 通过后用户等级立即生效 / rejected 拒绝需 notes）
export function auditMembershipRequest(id, data) {
  return request({
    url: `/admin/membership-requests/${id}`,
    method: 'put',
    data
  })
}
